<template>
    <div>
        <!-- <div class="preloader">
        <div class="wrapper">
            <div class="blobs">
                <div class="blob-center"></div>
                <div class="blob"></div>
                <div class="blob"></div>
                <div class="blob"></div>
                <div class="blob"></div>
                <div class="blob"></div>
                <div class="blob"></div>
            </div>
            <div>
                <div class="loader-canvas canvas-left"></div>
                <div class="loader-canvas canvas-right"></div>
            </div>
        </div>
        </div> -->
    <!-- =========== End of Loader ============ -->

    <main class="main">
        <Header></Header>
        <!-- =========== End of Spacer ============ -->
        <div class="pt-3 pt-lg-3"></div>
        <!-- =========== End of Spacer ============ -->

        <!-- =========== Start of Blog Body ============ -->
        <section class="blog-details">
            <div class="header-area header-area--no-image space--top">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header class="entry-header">
                                <h1 class="entry-title">چگونه کالای خوب ایرانی بخرم؟</h1>
                              
                                <div class="entry-image">
                                    <figure>
                                        <img src="/assets/img/single-blog-image-1.jpg" class='img-fluid' alt="Image">
                                    </figure>
                                </div>
                            </header>
                            <!-- end of header -->
                        </div>
                        <!-- end of col -->
                    </div>
                    <!-- end of row -->
                </div>
                <!-- end of container -->
            </div>
            <!-- end of header -->

            <div class="container">
                <div class="row mb-5">
                    <div class="col-12 col-lg-8 mx-auto">
                        <article class="article-content">
                            <div class="entry-content">
                                <div class="entry-meta">
                                    <span class="posted-on">
                                       در <a href="#"><time class="entry-date" datetime="2019-04-08T12:17:48+00:00">۸ آذر ۱۳۹۸</time></a>
                                    </span>
                                    <div class="cat-links">
                                        <ul class="post-categories">
                                            <li><a href="#">تکنولوژی</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.</p>
                                <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.</p>
                                <h3>نشانه های کیفیت</h3>
                                <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.</p>
                                <blockquote class="blockquote">
                                    <p>این یک کوتیشن است برای نمایش به شما</p><cite>مهدی شکرگزار<br></cite></blockquote>
                                <figure class="wp-block-image">
                                    <img src="/assets/img/single-blog-image-2.jpg"  class='img-fluid' alt="Image">
                                    <figcaption class="wp-caption-text">نمونه تصویر وبلاگ</figcaption>
                                </figure>
                                <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.</p>
                                <h3>نمونه ی یک لیست</h3>
                                <ul>
                                    <li>آیتم اول
                                        <ul>
                                            <li>آیتم اول
                                                <ul>
                                                    <li>آیتم اول</li>
                                                    <li>آیتم دوم</li>
                                                    <li>آیتم سوم</li>
                                                    <li>آیتم چهارم</li>
                                                </ul>
                                            </li>
                                            <li>آیتم دو</li>
                                            <li>آیتم سه</li>
                                            <li>آیتم جهار</li>
                                        </ul>
                                    </li>
                                    <li>آیتم دو</li>
                                    <li>آیتم سه</li>
                                    <li>آیتم جهار</li>
                                </ul>
                                <h3>لیست های ترتیبی</h3>
                                <ol start="8">
                                    <li>آیتم اول- شروع از ۸
                                        <ol>
                                            <li>آیتم اول
                                                <ol reversed="reversed">
                                                    <li>آیتم اول - برعکس</li>
                                                    <li>آیتم دوم</li>
                                                    <li>آیتم سوم</li>
                                                    <li>آیتم چهارم</li>
                                                </ol>
                                            </li>
                                            <li>آیتم دوم</li>
                                            <li>آیتم سوم</li>
                                            <li>آیتم چهارم</li>
                                        </ol>
                                    </li>
                                    <li>آیتم دوم</li>
                                    <li>آیتم سوم</li>
                                    <li>آیتم چهارم</li>
                                </ol>
                               
                               </div>
                        </article>
                    </div>
                    <!-- end of single card col-->
                </div>
                <!-- end of blog post row -->
            </div>
            <!-- end of article details body container-->

           
            <!-- end of meta, sahre and navigation area -->
          
            <!-- end of comment-->
        </section>
        <!-- =========== End of Blog Body ============ -->
        <!-- =========== Start of Newsletter ============ -->
        <Footer></Footer>
        <!-- =========== End of Newsletter ============ -->
    </main>
    </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/shared/Header'
import Footer from '@/components/shared/Footer'
export default {
  name: 'home',
  components: {
   
    Footer,
    Header
  }
}
</script>